import styles from './styles/NavigationBar.module.css'

import GroupOne from './GroupOne'
import GroupTwo from './GroupTwo'
export default function NavigationBar({ userIsLoged, usersex }) {
  return (
    <nav className={styles.navigation_bar}>
      <GroupOne />
      <GroupTwo userIsLoged={userIsLoged} usersex={usersex} />
    </nav >
  )
}